/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AgencyType {
  PRODUCER = 'PRODUCER',
  ENROLLMENT_TEAM = 'ENROLLMENT_TEAM',
  ZORRO_PARTNER = 'ZORRO_PARTNER',
}
